import appconfig from '../src/appconfig';
import logger from '../src/logger';
import { iframeReset } from './loader-styles';

export const isFunction = function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

export const setStyles = function (element, styles) {
  Object.assign(element.style, styles);
};

export const enterFailsafe = (error) => {
  logger.error('moin-widget critical error, entering failsafe', error);
  const container = document.getElementById('moin-ai-container');
  if (container) {
    setStyles(container, { display: 'none', background: 'red' });
  }
  /* if (widgetframe) setStyles(widgetframe, { display: 'none' });
  if (teaserframe) setStyles(teaserframe, { display: 'none' });
  if (buttonframe) setStyles(buttonframe, { display: 'none' }); */
};

export const preloadFont = function (container, url, sri) {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = url;
  link.as = 'font';
  if (sri) {
    link.integrity = sri;
  }
  link.type = 'font/woff2';
  link.crossOrigin = 'anonymous';
  container.appendChild(link);
};

export const injectStyleSheet = function (id, href, container, sri) {
  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.id = id;
  stylesheet.href = href;
  if (sri) {
    stylesheet.integrity = sri;
    stylesheet.crossOrigin = 'anonymous';
  }

  container.appendChild(stylesheet);
  stylesheet.addEventListener(
    'error',
    () => {
      throw new Error('error while loading stylesheet');
    },
    false,
  );
  return stylesheet;
};

export const createScriptTag = function (id, src, type, sri) {
  const script = document.createElement('script');
  script.id = id;
  script.src = src;
  script.async = false;
  if (type) script.type = type;
  if (sri) {
    script.integrity = sri;
    script.crossOrigin = 'anonymous';
  }

  // container.appendChild(script);
  return script;
};

export const injectTag = function (container, tag) {
  container.appendChild(tag);
  tag.addEventListener(
    'error',
    () => {
      throw new Error('error while loading injected tag');
    },
    false,
  );
};

export const injectDiv = function (id, container) {
  const div = document.createElement('div');
  div.id = id;
  container.appendChild(div);
  return div;
};

export const createIframe = async (id, container) => {
  const promise = new Promise((resolve) => {
    var frame = document.createElement('iframe');
    container.insertAdjacentElement('beforeend', frame);
    // chrome and ff load iframes differently so need a microtask to inject the content
    setTimeout(() => {
      frame.id = id;
      frame.title = id;
      frame.classList.add(id);
      resolve(frame);
    }, 100);
  });
  return promise;
};

export const constructIframe = async (id, container, basePath, SRI_CSS) => {
  const frame = await createIframe(id, container);
  const cssPath = appconfig.isDevelopment ? '' : basePath + '/main.css';
  injectStyleSheet('maincss', cssPath, frame.contentDocument.head, SRI_CSS);
  setStyles(frame, iframeReset);
  setStyles(frame, {
    /* border: '1px solid red', */ width: 0,
    height: 0,
    postition: 'absolute',
    bottom: '0px',
    right: '0px',
  });
  injectDiv('moinai-container', frame.contentDocument.body);
  return frame;
};

export const extractIds = function (scriptTag) {
  try {
    // extract the bot and channel id in the default case
    const scripturl = new URL(scriptTag.src);
    let botId = scripturl.searchParams.get('id');
    let channelId = scripturl.searchParams.get('channelid')
      ? scripturl.searchParams.get('channelid')
      : '';

    // we can override the bot and channel with search params in the url
    const siteUrl = new URL(window.location.href);
    if (siteUrl.searchParams.get('bot')) {
      botId = siteUrl.searchParams.get('bot');
    }
    if (siteUrl.searchParams.get('channelid')) {
      channelId = siteUrl.searchParams.get('channelid');
    }
    return {
      botId,
      channelId,
    };
  } catch {
    throw new Error('error parsing bot id');
  }
};

var relativeUrlTest = new RegExp('^(?:[a-z+]+:)?//', 'i');
export const isRelativeUrl = function (url) {
  return !relativeUrlTest.test(url.trim());
};

export const parseScriptTagUrl = function (scriptTagUrl) {
  let url = null;
  const cleanenUrl = scriptTagUrl.trim();
  if (isRelativeUrl(cleanenUrl)) {
    logger.log('url is relative, we need to build the absolute url');
    url = new URL(window.location.origin + cleanenUrl);
  } else {
    const inheritProtocol = cleanenUrl.startsWith('//');
    if (inheritProtocol) {
      url = new URL(location.protocol + cleanenUrl);
    } else {
      url = new URL(cleanenUrl);
    }
  }
  const pathIndex = url.href.indexOf('moin-loader.js');
  const basePath = `${url.href.substring(0, pathIndex - 1)}`;
  const loaderIndex = url.pathname.indexOf('moin-loader.js');
  const path = url.pathname.substring(0, loaderIndex - 1);

  return {
    href: url.href,
    origin: url.origin,
    pathname: url.pathname,
    path,
    basePath,
  };
};

export const devStyleInject = () => {
  // DEV ONLY



  const targetNode =

    document.getElementById('moin-ai-widget').contentDocument.head;
  const buttonPortal =

    document.getElementById('moin-ai-button').contentDocument.head;
  const teaserPortal =

    document.getElementById('moin-ai-teaser').contentDocument.head;

  // copy the initial injected styles  
  [...targetNode.children].forEach((item) => {
    buttonPortal.appendChild(item.cloneNode(true));
    teaserPortal.appendChild(item.cloneNode(true));
  })
  // add mutation oberserver for the hmr updates
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      [...mutation.addedNodes].forEach((node) => {
        buttonPortal.appendChild(node.cloneNode(true));
        teaserPortal.appendChild(node.cloneNode(true));
      });
    });
  });
  observer.observe(targetNode, {
    attributes: true,
    childList: true,
    subtree: true,
  });
};
